import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { shortenandHoverString } from '../../../../Components/helper';
import { ActiveIcon, DeleteIcon, DuplicateIcon, EditIcon, InactiveIcon, InfoIcon } from '../../../../bombiix-icon';
import { NewCheckbox } from '../../../../Components/PIM/common/NewCheckbox';

function LibraryCard({
  ele,
  i,
  handleCheckLibrary,
  selectedItems,
  handleDeleteById,
  handleDuplicateById,
  isFromGroup,
  hideEditDuplicate,
  CustomAddEditAccess,
  CustomDeleteAccess,
  handleActiveInactiveId,
  subBrandAccess,
}) {
  const { t } = useTranslation('common');

  return (
    <div className="common-listing-card card ">
      <div className="card-header">
        <ul className="card-header-icon">
          <li>
            <NewCheckbox
              name={`check_lib_${i}`}
              id={`check_lib_${i}`}
              checked={selectedItems?.includes(ele?._id)}
              onChange={(e) => handleCheckLibrary(e.target.checked, ele?._id)}
            />
          </li>
          {!hideEditDuplicate && CustomAddEditAccess && (
            <li>
              {isFromGroup ? (
                <Link title={t('CUSTOM_MODULES.LIBRARY.LIBRARY_CARD.EDIT')} to={`/libraries/custom-module/group/edit/${ele?._id}`}>
                  <EditIcon size={24} />
                </Link>
              ) : (
                <Link title={t('CUSTOM_MODULES.LIBRARY.LIBRARY_CARD.EDIT')} to={`/libraries/custom-module/library/edit/${ele?._id}`}>
                  <EditIcon size={24} />
                </Link>
              )}
            </li>
          )}

          {!isFromGroup && !hideEditDuplicate && CustomAddEditAccess && (
            <li>
              <button className="btn p-0 m-0" type="button" onClick={() => handleDuplicateById(ele?._id)} title="Duplicate" aria-label="Duplicate">
                <DuplicateIcon size={24} />
              </button>
            </li>
          )}
          {CustomDeleteAccess && (
            <li>
              <button
                type="button"
                className="btn p-0 m-0"
                onClick={() => handleActiveInactiveId(ele?._id, ele.isActive)}
                title={t('CUSTOM_MODULE.ACTIVE_INACTIVE')}
                aria-label={t('CUSTOM_MODULE.ACTIVE_INACTIVE')}
              >
                {ele.isActive ? (
                  <ActiveIcon size={24} className="text-success font-weight-bold" />
                ) : (
                  <InactiveIcon size={24} className="text-danger font-weight-bold" />
                )}
              </button>
            </li>
          )}
          {CustomDeleteAccess && (
            <li>
              <button
                type="button"
                className="btn p-0 m-0"
                onClick={() => handleDeleteById(ele?._id)}
                title={t('CUSTOM_MODULE.DELETE')}
                aria-label={t('CUSTOM_MODULE.DELETE')}
              >
                <DeleteIcon size={24} />
              </button>
            </li>
          )}
          <li>
            <button type="button" className="btn p-0 d-inline-flex">
              <OverlayTrigger
                placement="bottom"
                trigger="hover"
                rootClose
                overlay={
                  <Popover className="custom-popover modified-popover">
                    <Popover.Content>
                      <div>
                        <p className="mb-0">
                          <strong>{t('COLOR_WAY_CARD.CREATED_BY_DATE_TIME')}&nbsp;</strong>
                          <span>{`${ele?.createdBy} | ${ele?.createdAt && moment(ele?.createdAt).format('DD-MMMM-YYYY, HH:mm a')}`}</span>
                        </p>
                        <p className="mb-0">
                          <strong>{t('COLOR_WAY_CARD.MODIFIED_BY_DATE_TIME')}&nbsp;</strong>
                          <span>{`${ele?.modifiedBy} | ${ele?.updatedAt && moment(ele?.updatedAt).format('DD-MMMM-YYYY, HH:mm a')}`}</span>
                        </p>
                      </div>
                    </Popover.Content>
                  </Popover>
                }
              >
                <InfoIcon size={24} />
              </OverlayTrigger>
            </button>
          </li>
        </ul>
      </div>
      <div className="card-body">
        <h4 className="title">{isFromGroup ? ele?.groupName : ele?.moduleName}</h4>
        <ul className="card-ul">
          <li>
            <strong>{t('CUSTOM_MODULE.BRAND')}: </strong>
            {shortenandHoverString(ele?.brandId?.join(', '), 40) || '--'}
          </li>
          {subBrandAccess === true && (
            <li>
              <strong>{t('CUSTOM_MODULE.SUB_BRAND')}: </strong>
              {shortenandHoverString(ele?.subBrandId?.join(', '), 40) || '--'}
            </li>
          )}
          <li>
            <strong>{t('CUSTOM_MODULE.PRODUCT_TYPE')}: </strong>
            {shortenandHoverString(ele?.productTypeId?.join(', '), 40) || '--'}
          </li>
          <li>
            <strong>{t('CUSTOM_MODULE.SUPPLIER')}: </strong>
            {shortenandHoverString(ele?.supplierId?.join(', '), 40) || '--'}
          </li>
        </ul>
      </div>
    </div>
  );
}
export default LibraryCard;
